import type { FC } from 'react';
import type * as THREE from 'three';
import type { IAttachedLineProps } from '@/engine/UIPresentation/Interfaces.ts';

interface Props {
  attachedLine: IAttachedLineProps | undefined;
  point2D: THREE.Vector2 | undefined;
}

export const CustomSVGLine: FC<Props> = ({ attachedLine, point2D }) => {
  const dashNumber = 4;

  return attachedLine && point2D ? (
    <line
      stroke={attachedLine.stroke}
      strokeDasharray={attachedLine.isStrokeDashed ? dashNumber : undefined}
      x1={point2D.x}
      x2={attachedLine.x1}
      y1={point2D.y}
      y2={attachedLine.y1}
    ></line>
  ) : (
    <></>
  );
};
